module.exports = __webpack_public_path__ + "img/D1.240da6d1.svg";